// Types for ViddStar video platform

export type VideoStatus = 'pending' | 'approved' | 'rejected';
export type VideoSource = 'upload' | 'youtube' | 'vimeo';

export interface Video {
  id: string;
  title: string;
  tag: string; // Short uppercase tag like "WILD" or "CAUGHT ON CAMERA"
  description: string;
  source: VideoSource;
  url: string; // YouTube/Vimeo URL or upload path
  embedId?: string; // YouTube/Vimeo video ID
  thumbnail: string;
  thumbnailAlt: string;
  views: number;
  likesCount?: number;
  comments: number;
  submittedBy: string;
  submittedAt: string;
  status: VideoStatus;
  category: string;
}

export interface SubmitVideoForm {
  title: string;
  tag: string;
  description: string;
  source: VideoSource;
  url: string;
  submittedBy: string;
  category: string;
}

export interface AdminAction {
  videoId: string;
  action: 'approve' | 'reject';
}

export const VIDEO_CATEGORIES = [
'Fights & Brawls',
'Sports',
'Entertainment',
'News & Politics',
'Funny & Viral',
'Music',
'Street Life',
'Crazy Moments',
'Feel Good',
'Code Red Interviews',
'Other'];


// Mock approved videos for display
export const MOCK_VIDEOS: Video[] = [
{
  id: 'v001',
  title: 'Dude Tries To Rob A Convenience Store But The Clerk Was Ready For Him!',
  tag: 'NOT TODAY',
  description: 'A would-be robber picked the wrong store when the clerk pulled out his own surprise.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1a3170492-1769518513363.png",
  thumbnailAlt: 'Security camera footage of a convenience store interior at night',
  views: 142830,
  comments: 287,
  submittedBy: 'StreetReporter',
  submittedAt: '2024-01-15',
  status: 'approved',
  category: 'Crazy Moments'
},
{
  id: 'v002',
  title: 'Skateboarder Lands The Most Insane Trick Down A 20-Stair Rail In Downtown LA',
  tag: 'UNREAL',
  description: 'This skater has been trying this trick for 3 years. Watch the moment he finally lands it.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1679261202016-1abb6b486179",
  thumbnailAlt: 'Skateboarder performing a trick on a large staircase rail in an urban setting',
  views: 98450,
  comments: 156,
  submittedBy: 'SkateOrDie99',
  submittedAt: '2024-01-14',
  status: 'approved',
  category: 'Sports'
},
{
  id: 'v003',
  title: 'Two Karens Try To Jump A Fast Food Worker But She Was Built Different',
  tag: 'SHE SNAPPED',
  description: 'They thought it was going to be easy but they had no idea who they were dealing with.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1689479799148-b8a3ee8bfe3a",
  thumbnailAlt: 'Fast food restaurant exterior with people gathered outside',
  views: 234100,
  comments: 412,
  submittedBy: 'VidCapture',
  submittedAt: '2024-01-14',
  status: 'approved',
  category: 'Fights & Brawls'
},
{
  id: 'v004',
  title: 'Local Rapper Drops Surprise Freestyle On The Corner And The Whole Block Goes Crazy',
  tag: 'BARS ON BARS',
  description: 'Nobody expected this to happen on a Tuesday afternoon. The crowd reaction says it all.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_125c09f12-1776918627907.png",
  thumbnailAlt: 'Crowd gathered around a rapper performing on a city street corner',
  views: 67890,
  comments: 98,
  submittedBy: 'HoodReporter',
  submittedAt: '2024-01-13',
  status: 'approved',
  category: 'Music'
},
{
  id: 'v005',
  title: 'Dad Catches His Son Sneaking Back In At 3AM And The Punishment Was Legendary',
  tag: 'CAUGHT IN 4K',
  description: 'Dad set up cameras and waited. The look on the son\'s face when the lights came on is priceless.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1567092784576-ebca18b69af5",
  thumbnailAlt: 'Home security camera footage showing a dark hallway at night',
  views: 189200,
  comments: 334,
  submittedBy: 'FamilyDrama101',
  submittedAt: '2024-01-13',
  status: 'approved',
  category: 'Funny & Viral'
},
{
  id: 'v006',
  title: 'MMA Fighter Challenges Random Guy At The Gym And Gets The Shock Of His Life',
  tag: 'HUMBLE PIE',
  description: 'He was talking all that trash until the random guy revealed he was a former champion.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1a687c94f-1769173152665.png",
  thumbnailAlt: 'Two men sparring in a boxing gym with other fighters watching',
  views: 312450,
  comments: 521,
  submittedBy: 'GymRat2024',
  submittedAt: '2024-01-12',
  status: 'approved',
  category: 'Sports'
},
{
  id: 'v007',
  title: 'Grandma Pulls Up To The Block Party And Shows The Young Ones How To Really Dance',
  tag: 'RESPECT THE OG',
  description: 'She\'s 74 years old and still has more moves than everyone half her age. The crowd went insane.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1714253352879-e8303759e07b",
  thumbnailAlt: 'Outdoor block party with people dancing and celebrating in a neighborhood street',
  views: 445600,
  comments: 678,
  submittedBy: 'BlockPartyKing',
  submittedAt: '2024-01-12',
  status: 'approved',
  category: 'Feel Good'
},
{
  id: 'v008',
  title: 'Road Rage Incident Ends With The Most Unexpected Plot Twist You\'ll See All Week',
  tag: 'PLOT TWIST',
  description: 'What started as a typical road rage situation turned into something nobody could have predicted.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_11a9c3652-1786233685513.png",
  thumbnailAlt: 'Dashcam footage of a highway with cars stopped during a road rage incident',
  views: 278900,
  comments: 445,
  submittedBy: 'DashCamKing',
  submittedAt: '2024-01-11',
  status: 'approved',
  category: 'Crazy Moments'
},
{
  id: 'v009',
  title: 'Street Performer Stops Traffic In Times Square With A Performance Nobody Expected',
  tag: 'GOATED',
  description: 'He set up his equipment on the corner and within 10 minutes had thousands of people stopped.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1683218819028-5d4812ca370e",
  thumbnailAlt: 'Crowded Times Square at night with a street performer surrounded by spectators',
  views: 156780,
  comments: 203,
  submittedBy: 'NYCVibes',
  submittedAt: '2024-01-11',
  status: 'approved',
  category: 'Entertainment'
},
{
  id: 'v010',
  title: 'Cop Pulls Over The Wrong Car And Gets Schooled On Constitutional Rights By A Law Student',
  tag: 'KNOW YOUR RIGHTS',
  description: 'She calmly recited every amendment and the officer had no choice but to let her go.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1707236719677-35b9fe8dfeba",
  thumbnailAlt: 'Police car with flashing lights pulled over on the side of a road at night',
  views: 523400,
  comments: 892,
  submittedBy: 'LegalEagle',
  submittedAt: '2024-01-10',
  status: 'approved',
  category: 'News & Politics'
},
{
  id: 'v011',
  title: 'Little Kid Challenges Pro Basketball Player To A 1-on-1 And Actually Scores On Him',
  tag: 'FUTURE STAR',
  description: 'The pro was just playing around until the kid hit three straight buckets. Then it got serious.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1651444653424-b8c9f5d4cd4a",
  thumbnailAlt: 'Outdoor basketball court with a young child playing against an adult player',
  views: 387200,
  comments: 567,
  submittedBy: 'HoopDreams',
  submittedAt: '2024-01-10',
  status: 'approved',
  category: 'Sports'
},
{
  id: 'v012',
  title: 'Woman Confronts Her Neighbor About Parking And It Escalates Faster Than Anyone Expected',
  tag: 'NEIGHBORHOOD BEEF',
  description: 'What started as a polite conversation turned into the most dramatic parking dispute ever recorded.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1694284701639-0230fef8dc5b",
  thumbnailAlt: 'Residential street with cars parked and two people arguing near a driveway',
  views: 201340,
  comments: 378,
  submittedBy: 'NeighborhoodWatch',
  submittedAt: '2024-01-09',
  status: 'approved',
  category: 'Street Life'
}];


// Mock pending videos for admin panel
export const MOCK_PENDING_VIDEOS: Video[] = [
{
  id: 'p001',
  title: 'Security Guard Gets Caught Sleeping On The Job By His Own Boss',
  tag: 'BUSTED',
  description: 'The boss walked in at exactly the wrong moment. The security guard had no idea.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://images.unsplash.com/photo-1715174559221-18587086377c",
  thumbnailAlt: 'Office security desk with a sleeping guard caught on camera',
  views: 0,
  comments: 0,
  submittedBy: 'OfficeSnitch',
  submittedAt: '2024-01-16',
  status: 'pending',
  category: 'Funny & Viral'
},
{
  id: 'p002',
  title: 'Dude Tries To Flex His New Car But It Breaks Down Right In Front Of Everyone',
  tag: 'L OF THE YEAR',
  description: 'He pulled up blasting music and then the engine just died. The crowd reaction is everything.',
  source: 'vimeo',
  url: 'https://vimeo.com/123456789',
  embedId: '123456789',
  thumbnail: "https://images.unsplash.com/photo-1733257219666-2823e866b0d3",
  thumbnailAlt: 'Luxury car broken down on a city street with people watching',
  views: 0,
  comments: 0,
  submittedBy: 'CarCulture',
  submittedAt: '2024-01-16',
  status: 'pending',
  category: 'Funny & Viral'
},
{
  id: 'p003',
  title: 'Boxer Trains With His 70-Year-Old Father Who Still Has Hands Like A Young Man',
  tag: 'POPS GOT HANDS',
  description: 'The son thought he could go easy on his dad. He was very wrong.',
  source: 'youtube',
  url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  embedId: 'dQw4w9WgXcQ',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1a687c94f-1769173152665.png",
  thumbnailAlt: 'Two boxers sparring in a gym, one older and one younger',
  views: 0,
  comments: 0,
  submittedBy: 'BoxingFanatic',
  submittedAt: '2024-01-15',
  status: 'pending',
  category: 'Sports'
}];


export function formatViews(views: number): string {
  if (views >= 1000000) {
    return (views / 1000000).toFixed(1) + 'M';
  }
  if (views >= 1000) {
    return views.toLocaleString();
  }
  return views.toString();
}

export function extractYouTubeId(url: string): string | null {
  const patterns = [
  /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
  /youtube\.com\/shorts\/([^&\n?#]+)/];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return null;
}

export function extractVimeoId(url: string): string | null {
  const match = url.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
  return match ? match[1] : null;
}

export function getYouTubeThumbnail(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}